/**
 * Right-arrow in an EMPTY text input accepts its placeholder as the value.
 *
 * The site fields show an example in grey ("3777 Kingsway", "Burnaby"); on a
 * phone, typing what is already on screen is the slow part. → takes it. Only
 * when the field is empty, so the key still moves the caret once anything has
 * been typed, and only for inputs that actually carry a placeholder.
 *
 * Applied as a Svelte action to a container so a form opts in once:
 *
 *     <div use:acceptPlaceholder> ... </div>
 *
 * The value is set through the native setter and followed by an `input`
 * event, which is what a `bind:value` listens for — assigning `.value`
 * directly would leave the bound state stale.
 */

function accept(el: HTMLInputElement): void {
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
  if (setter) setter.call(el, el.placeholder);
  else el.value = el.placeholder;
  el.dispatchEvent(new Event('input', { bubbles: true }));
}

export function acceptPlaceholder(node: HTMLElement) {
  function onKeydown(event: KeyboardEvent) {
    if (event.key !== 'ArrowRight' || event.altKey || event.ctrlKey || event.metaKey) return;
    const el = event.target as HTMLElement | null;
    if (!(el instanceof HTMLInputElement)) return;
    if (el.type !== 'text' && el.type !== 'search') return;
    if (el.value !== '' || el.placeholder === '') return;
    event.preventDefault();
    accept(el);
  }
  node.addEventListener('keydown', onKeydown);
  return {
    destroy() {
      node.removeEventListener('keydown', onKeydown);
    }
  };
}
